"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueries } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { commonApiFetch } from "@/services/api/common-api";
import type { RatingWithProfileInfoAndLevel } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { Page } from "@/helpers/Types";
import OverlappingAvatars from "@/components/common/OverlappingAvatars";
import { RateMatter } from "@/types/enums";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { MouseEvent } from "react";
const STALE_TIME = 5 * 60 * 1000;
export default function TopRaterAvatars(t0) {
  const $ = _c(27);
  const {
    handleOrWallet,
    category,
    matter: t1,
    withLinks: t2,
    onAvatarClick,
    count: t3,
    size: t4
  } = t0;
  const matter = t1 === undefined ? RateMatter.REP : t1;
  const withLinks = t2 === undefined ? true : t2;
  const count = t3 === undefined ? 5 : t3;
  const size = t4 === undefined ? "sm" : t4;
  const t5 = `${count}`;
  let params;
  if ($[0] !== category || $[1] !== matter || $[2] !== t5) {
    params = {
      page: "1",
      page_size: t5,
      order: "desc",
      order_by: "rating",
      given: "false"
    };
    if (matter === RateMatter.REP && category) {
      params.category = category;
    }
    $[0] = category;
    $[1] = matter;
    $[2] = t5;
    $[3] = params;
  } else {
    params = $[3];
  }
  const ratingsEndpoint = matter === RateMatter.NIC ? `profiles/${handleOrWallet}/cic/ratings/by-rater` : `profiles/${handleOrWallet}/rep/ratings/by-rater`;
  let t6;
  if ($[4] !== handleOrWallet) {
    t6 = handleOrWallet.toLowerCase();
    $[4] = handleOrWallet;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== category || $[7] !== count || $[8] !== matter || $[9] !== t6) {
    t7 = [QueryKey.PROFILE_RATERS, {
      handleOrWallet: t6,
      matter,
      category,
      count
    }];
    $[6] = category;
    $[7] = count;
    $[8] = matter;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== params || $[12] !== ratingsEndpoint) {
    t8 = async () => await commonApiFetch({
      endpoint: ratingsEndpoint,
      params
    });
    $[11] = params;
    $[12] = ratingsEndpoint;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = !!handleOrWallet;
  let t10;
  if ($[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = {
      queryKey: t7,
      queryFn: t8,
      enabled: t9,
      staleTime: STALE_TIME
    };
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const {
    data: ratersPage
  } = useQuery(t10);
  const raterHandles = ratersPage?.data.map(_temp) ?? [];
  const ratingByHandle = new Map(ratersPage?.data.map(_temp2) ?? []);
  const t11 = raterHandles.map(_temp3);
  let t12;
  if ($[18] !== t11) {
    t12 = {
      queries: t11
    };
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const identityQueries = useQueries(t12);
  const items = identityQueries.filter(_temp4).map(q_0 => {
    const identity = q_0.data;
    const target = identity.handle ?? identity.primary_wallet;
    const rating = target ? ratingByHandle.get(target.toLowerCase()) : undefined;
    const tooltipContent = rating === undefined ? undefined : <span>{target} · {formatNumberWithCommas(rating)}</span>;
    return {
      key: target,
      pfpUrl: identity.pfp ?? null,
      ...(withLinks && target ? {
        href: `/${target}`
      } : {}),
      ariaLabel: target,
      fallback: identity.handle ? identity.handle.charAt(0).toUpperCase() : "?",
      title: target,
      tooltipContent
    };
  });
  if (items.length === 0) {
    return null;
  }
  let t13;
  if ($[20] !== onAvatarClick) {
    t13 = e => onAvatarClick?.(e);
    $[20] = onAvatarClick;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== count || $[23] !== items || $[24] !== size || $[25] !== t13) {
    t14 = <OverlappingAvatars items={items} size={size} maxCount={count} onItemClick={t13} />;
    $[22] = count;
    $[23] = items;
    $[24] = size;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}
function _temp4(q) {
  return q.data;
}
function _temp3(handle) {
  return {
    queryKey: [QueryKey.PROFILE, handle.toLowerCase()],
    queryFn: async () => await commonApiFetch({
      endpoint: `identities/${handle.toLowerCase()}`
    }),
    enabled: !!handle,
    staleTime: STALE_TIME
  };
}
function _temp2(r_0) {
  return [r_0.handle.toLowerCase(), r_0.rating];
}
function _temp(r) {
  return r.handle;
}